module.exports = __webpack_public_path__ + "linea-basic-10.ce776cff0588d8e8385c.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/assets/linea/fonts/linea-basic-10.svg
// module id = ../../../../../src/assets/linea/fonts/linea-basic-10.svg
// module chunks = styles